import { render, staticRenderFns } from "./PagamentoContas.vue?vue&type=template&id=82418f92"
import script from "./PagamentoContas.vue?vue&type=script&lang=ts"
export * from "./PagamentoContas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports